import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

var formatInt = function formatInt(input) {
  return new Intl.NumberFormat("sv-SE", {
    maximumFractionDigits: 0
  }).format(input);
};

var Address = /*#__PURE__*/function () {
  function Address(data) {
    _classCallCheck(this, Address);

    _defineProperty(this, "data", void 0);

    this.data = data;
  }

  _createClass(Address, [{
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.streetAddress, " - ").concat(this.data.city);
    }
  }, {
    key: "toLatLng",
    value: function toLatLng() {
      return this.data.coordinates;
    }
  }, {
    key: "streetAddress",
    get: function get() {
      return "".concat(this.data.street, " ").concat(this.data.locator);
    }
  }, {
    key: "city",
    get: function get() {
      return this.data.city;
    }
  }, {
    key: "street",
    get: function get() {
      return this.data.street;
    }
  }, {
    key: "lat",
    get: function get() {
      return this.data.coordinates.lat;
    }
  }, {
    key: "lng",
    get: function get() {
      return this.data.coordinates.lng;
    }
  }]);

  return Address;
}();

var DEFAULT_LISTING_IMAGE_URL = "https://storage.googleapis.com/static-yta-files/default_pic_listing.jpg";

var Listing = /*#__PURE__*/function () {
  function Listing(data) {
    _classCallCheck(this, Listing);

    _defineProperty(this, "data", void 0);

    _defineProperty(this, "currentDate", void 0);

    _defineProperty(this, "created", void 0);

    _defineProperty(this, "address", void 0);

    this.data = data;
    this.currentDate = new Date();
    this.address = new Address(this.data.address);
    this.created = new Date(data.created);
  }

  _createClass(Listing, [{
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }, {
    key: "displayType",
    value: function displayType() {
      if (this.data.serviced_office) {
        return "Kontorshotell";
      }

      if (this.data.office) {
        return "Kontor";
      }

      return "Lokal";
    }
  }, {
    key: "displaySize",
    value: function displaySize() {
      var _this$data$size = this.data.size,
          min = _this$data$size.min,
          max = _this$data$size.max;

      if (min < max) {
        return "".concat(min, " - ").concat(max, " m\xB2");
      } else {
        return min + " m²";
      }
    }
  }, {
    key: "displayTitle",
    value: function displayTitle() {
      return this.data.title;
    }
  }, {
    key: "displayFloor",
    value: function displayFloor() {
      return this.data.floor;
    }
  }, {
    key: "displayConstructionYear",
    value: function displayConstructionYear() {
      return this.data.construction_year ? this.data.construction_year.toString() : "";
    }
  }, {
    key: "displayPublicTransport",
    value: function displayPublicTransport() {
      return this.data.public_transport;
    }
  }, {
    key: "displayParking",
    value: function displayParking() {
      return this.data.parking_description;
    }
  }, {
    key: "displayServicesNearby",
    value: function displayServicesNearby() {
      return this.data.services_nearby;
    }
  }, {
    key: "displayAvailability",
    value: function displayAvailability() {
      if (!this.data.availability_date) {
        return this.data.availability_details;
      }

      if (!this.data.availability_details) {
        return this.data.availability_date;
      }

      return "".concat(this.data.availability_date, ": ").concat(this.data.availability_details);
    }
  }, {
    key: "displayRentDetails",
    value: function displayRentDetails() {
      return this.data.rent_details;
    }
  }, {
    key: "displayActualRent",
    value: function displayActualRent() {
      var rent = this.monthlyRent; // Display price for medium and high confidence

      if (!rent || this.data.rent_confidence < 3) {
        return "";
      }

      return formatInt(rent) + " kr/mån";
    }
  }, {
    key: "displayEstimatedRent",
    value: function displayEstimatedRent() {
      var rent = this.monthlyRent;
      return rent ? formatInt(rent) + " kr/mån" : "";
    }
    /**
     * @deprecated since version 1.6.0. Use displayActualRent or displayEstimatedRent instead.
     */

  }, {
    key: "displayRent",
    value: function displayRent() {
      return this.displayEstimatedRent();
    }
  }, {
    key: "displayNeighbordhood",
    value: function displayNeighbordhood() {
      /**
       * @todo when we implement neighborhoods in the new API
       * Right now we have mothing like it so we have to give up on it
       */
      return "";
    }
  }, {
    key: "displayWorkspaces",
    value: function displayWorkspaces() {
      var _this$data$workspaces = this.data.workspaces,
          min = _this$data$workspaces.min,
          max = _this$data$workspaces.max;
      var text = "";

      if (min) {
        text += min;

        if (max) {
          text += " - " + max;
        }
      } else if (max) {
        text += max;
      } else {
        return "";
      }

      text += " arbetsplatser";
      return text;
    }
  }, {
    key: "displaySurroundingsDescription",
    value: function displaySurroundingsDescription() {
      return this.data.surroundings_description;
    }
  }, {
    key: "displayDescription",
    value: function displayDescription() {
      return this.data.description;
    }
  }, {
    key: "displayShortDescription",
    value: function displayShortDescription() {
      return this.data.extract;
    }
  }, {
    key: "displayAge",
    value: function displayAge() {
      var now = this.currentDate.getTime();
      var added = Math.floor((now - this.created.getTime()) / 86400000);
      if (added > 90) return "längre än 3 månader";
      var text = added.toString();

      if (added > 1) {
        text += " dagar sedan";
      } else if (added === 1) {
        text = "igår";
      } else {
        text = "idag";
      }

      return text;
    }
  }, {
    key: "id",
    get: function get() {
      return this.data.id;
    }
  }, {
    key: "isOverridden",
    get: function get() {
      return this.data.overridden;
    }
  }, {
    key: "isPublic",
    get: function get() {
      return this.data.public;
    }
  }, {
    key: "isListed",
    get: function get() {
      return this.data.listed;
    }
  }, {
    key: "isOffice",
    get: function get() {
      return this.data.office;
    }
  }, {
    key: "isServicedOffice",
    get: function get() {
      return this.data.serviced_office;
    }
  }, {
    key: "images",
    get: function get() {
      /**
       * LEGACY
       * Prepares all the pictures of the listing for the image carousel
       * As we are giving up on the 3D tours this could be simplified?
       */
      var images = this.virtualTours.map(function (_ref) {
        var image = _ref.image;
        return {
          url: image,
          tour: true
        };
      }).concat(this.data.images.map(function (url) {
        return {
          url: url,
          tour: false
        };
      }));

      if (images.length == 0) {
        return [{
          url: DEFAULT_LISTING_IMAGE_URL,
          tour: false
        }];
      }

      return images;
    }
  }, {
    key: "url",
    get: function get() {
      return "/" + this.data.url;
    }
  }, {
    key: "metricRent",
    get: function get() {
      if (!this.data.total_rent_per_m2) {
        return null;
      } // return the real rent only if we are sure about it


      if (this.data.rent_confidence === 5) {
        return this.data.total_rent_per_m2;
      }

      return this.data.total_rent_per_m2 + 100;
    }
  }, {
    key: "monthlyRent",
    get: function get() {
      if (!this.data.total_rent_per_m2 || !this.metricRent) {
        return null;
      }

      return Math.floor(this.metricRent * this.data.size.max / 1200) * 100;
    }
  }, {
    key: "virtualTours",
    get: function get() {
      /**
       * @deprecated Since we are removing 3D tours
       */
      return this.data.virtual_tours;
    }
  }, {
    key: "floorplans",
    get: function get() {
      return this.data.floorplans;
    }
  }, {
    key: "documents",
    get: function get() {
      return this.data.documents;
    }
  }, {
    key: "rentConfidence",
    get: function get() {
      return this.data.rent_confidence;
    }
  }, {
    key: "minSize",
    get: function get() {
      return this.data.size.min;
    }
  }, {
    key: "maxSize",
    get: function get() {
      return this.data.size.max;
    }
  }, {
    key: "minWorkspaces",
    get: function get() {
      return this.data.workspaces.min;
    }
  }, {
    key: "maxWorkspaces",
    get: function get() {
      return this.data.workspaces.max;
    }
  }, {
    key: "contact",
    get: function get() {
      return this.data.contact;
    }
  }, {
    key: "legacyContactData",
    get: function get() {
      /**
       * @deprecated we should not use the contact inside the listing but we need it right now in the frontend
       * We should remove this ASAP but it requires quite a bit of refactoring
       */
      return this.data.contact_data;
    }
  }, {
    key: "broker",
    get: function get() {
      return this.data.broker;
    }
  }]);

  return Listing;
}();

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var SUGGESTION_STAGE = {
  api_value: "pristine",
  title: "Förslag"
};
var SHORTLIST_STAGE = {
  api_value: "accepted",
  title: "Shortlist"
};
var SHOWING_STAGE = {
  api_value: "showing",
  title: "Visning"
};
var NEGOTIATION_STAGE = {
  api_value: "negotiation",
  title: "Förhandling"
};
var SIGNED_STAGE = {
  api_value: "signed",
  title: "Signerat avtal"
};
var STAGES = [SUGGESTION_STAGE, SHORTLIST_STAGE, SHOWING_STAGE, NEGOTIATION_STAGE, SIGNED_STAGE];

var Offer = /*#__PURE__*/function () {
  function Offer(data) {
    _classCallCheck(this, Offer);

    _defineProperty(this, "data", void 0);

    this.data = data;
  }
  /**
   * Getters for offer related fields
   */


  _createClass(Offer, [{
    key: "displayRent",
    value: function displayRent() {
      if (!this.monthlyRent) {
        return "";
      } else {
        return formatInt(this.monthlyRent) + " kr/mån";
      }
    }
  }, {
    key: "documents",
    get: function get() {
      return this.data.files;
    }
  }, {
    key: "monthlyRent",
    get: function get() {
      return this.data.monthly_rent;
    }
  }, {
    key: "terms",
    get: function get() {
      return this.data.terms;
    }
  }, {
    key: "type",
    get: function get() {
      return this.data.type;
    }
  }]);

  return Offer;
}();

var Proposition = /*#__PURE__*/function () {
  function Proposition(data) {
    _classCallCheck(this, Proposition);

    _defineProperty(this, "currentDate", void 0);

    _defineProperty(this, "data", void 0);

    _defineProperty(this, "created", void 0);

    _defineProperty(this, "stage", void 0);

    _defineProperty(this, "offer", void 0);

    _defineProperty(this, "address", void 0);

    this.data = data;
    this.created = new Date(data.created);
    this.currentDate = new Date();
    this.stage = STAGES.find(function (s) {
      return s.api_value === data.status;
    }); // STAGES should be exhaustive for this cast to be valid

    this.address = new Address(data.address);
    this.offer = new Offer(data.offer);
  }

  _createClass(Proposition, [{
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }, {
    key: "displayAvailabilityDetails",

    /**
     * Formatting functions for the listing fields
     */

    /**
     * @deprecated since version 2.3.0. Use displayAvailability instead.
     */
    value: function displayAvailabilityDetails() {
      return this.data.availability_details;
    }
  }, {
    key: "displayAvailability",
    value: function displayAvailability() {
      return this.data.availability_details || this.data.availability_date || "";
    }
  }, {
    key: "displayOriginalRent",
    value: function displayOriginalRent() {
      if (!this.originalMonthlyRent) {
        return "";
      } else {
        return formatInt(this.originalMonthlyRent) + " kr/mån";
      }
    }
  }, {
    key: "displayRent",
    value: function displayRent() {
      return this.offer.displayRent() || this.displayOriginalRent();
    }
  }, {
    key: "displaySize",
    value: function displaySize() {
      if (!this.data.size) {
        return "";
      }

      return "".concat(this.data.size, " m\xB2");
    }
  }, {
    key: "displayWorkspaces",
    value: function displayWorkspaces() {
      if (!this.data.workspaces) {
        return "";
      } else {
        return "".concat(this.data.workspaces, " arbetsplatser");
      }
    }
  }, {
    key: "id",
    get: function get() {
      return this.data.id;
    }
  }, {
    key: "shortlist",
    get: function get() {
      return this.data.shortlist;
    }
  }, {
    key: "listing",
    get: function get() {
      return this.data.listing;
    }
  }, {
    key: "contact",
    get: function get() {
      return this.data.contact;
    }
  }, {
    key: "curated",
    get: function get() {
      return this.data.curated;
    }
  }, {
    key: "priority",
    get: function get() {
      return this.data.priority;
    }
  }, {
    key: "comment",
    get: function get() {
      return this.data.comment;
    }
  }, {
    key: "info",
    get: function get() {
      return this.data.info;
    }
  }, {
    key: "nextAction",
    get: function get() {
      return this.data.next_action;
    }
    /**
     * @deprecated Use nextAction instead
     */

  }, {
    key: "next_action",
    get: function get() {
      return this.nextAction;
    }
    /**
     * @deprecated Use offer.documents instead
     */

  }, {
    key: "files",
    get: function get() {
      return this.offer.documents;
    }
    /**
     * Getters for listing related fields
     */

  }, {
    key: "documents",
    get: function get() {
      return this.data.documents;
    }
  }, {
    key: "images",
    get: function get() {
      return this.data.images;
    }
  }, {
    key: "floorplans",
    get: function get() {
      return this.data.floorplans;
    }
  }, {
    key: "description",
    get: function get() {
      return this.data.description;
    }
  }, {
    key: "originalMonthlyRent",
    get: function get() {
      return this.data.original_monthly_rent;
    }
  }, {
    key: "size",
    get: function get() {
      return this.data.size;
    }
  }, {
    key: "workspaces",
    get: function get() {
      return this.data.workspaces;
    }
  }, {
    key: "floor",
    get: function get() {
      return this.data.floor;
    }
  }, {
    key: "availabilityDate",
    get: function get() {
      return this.data.availability_date;
    }
  }, {
    key: "isServicedOffice",
    get: function get() {
      return this.data.is_serviced_office;
    }
  }, {
    key: "isExpired",
    get: function get() {
      return this.data.expired !== null && new Date(this.data.expired) < this.currentDate;
    }
  }]);

  return Proposition;
}();

function listingToPropositionPayload(listing, shortlist) {
  return {
    offer: {
      type: "suggestion",
      monthly_rent: null,
      terms: listing.displayRentDetails(),
      files: []
    },
    expired: null,
    listing: listing.id,
    rooms: [],
    shortlist: shortlist,
    contact: listing.contact,
    priority: 0,
    status: "pristine",
    comment: "",
    curated: false,
    info: "",
    next_action: "",
    size: listing.maxSize,
    workspaces: listing.maxWorkspaces,
    original_monthly_rent: listing.rentConfidence > 2 ? listing.monthlyRent : null,
    documents: listing.documents,
    images: listing.images.map(function (obj) {
      return obj.url;
    }),
    floorplans: listing.floorplans,
    floor: listing.displayFloor(),
    is_serviced_office: listing.isServicedOffice,
    availability_details: listing.displayAvailability(),
    availability_date: null,
    description: buildPropositionDescription(listing),
    address: listing.address.data
  };
}

function roomsToPropositionPayload(shortlist, provider, location) {
  var _ref, _ref2;

  var available = true;
  var latestAvailabilityDate = null;

  for (var _len = arguments.length, rooms = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rooms[_key - 3] = arguments[_key];
  }

  for (var _i = 0, _rooms = rooms; _i < _rooms.length; _i++) {
    var room = _rooms[_i];

    if (!latestAvailabilityDate || room.availability && room.availability > latestAvailabilityDate) {
      latestAvailabilityDate = room.availability;
    }

    if (room.state === "OFF") {
      available = false;
    }
  }

  var availability_date = null,
      availability_details = "";

  if (available && latestAvailabilityDate) {
    availability_date = latestAvailabilityDate;
  } else if (available) {
    availability_details = "Tillgänglig";
  } else {
    availability_details = "Ej tillgänglig";
  }

  return {
    offer: {
      type: "suggestion",
      monthly_rent: null,
      terms: "",
      files: []
    },
    listing: null,
    expired: null,
    rooms: rooms.map(function (r) {
      return r.id;
    }),
    shortlist: shortlist,
    contact: null,
    priority: 0,
    status: "pristine",
    comment: "",
    curated: false,
    info: "",
    next_action: "",
    size: rooms.reduce(function (sum, room) {
      return sum + room.size;
    }, 0),
    workspaces: rooms.reduce(function (sum, room) {
      return sum + room.max_workspaces;
    }, 0),
    original_monthly_rent: rooms.reduce(function (sum, room) {
      return sum + room.price;
    }, 0),
    documents: location.documents.concat(provider.documents),
    images: (_ref = []).concat.apply(_ref, _toConsumableArray(rooms.map(function (r) {
      return r.images;
    })).concat([location.images])),
    floorplans: (_ref2 = []).concat.apply(_ref2, _toConsumableArray(rooms.map(function (r) {
      return r.floorplans;
    })).concat([location.floorplans])),
    floor: "",
    // We could maybe get that but it would be very complicated here
    is_serviced_office: true,
    availability_details: availability_details,
    availability_date: availability_date,
    description: buildRoomsDescription.apply(void 0, [provider, location].concat(rooms)),
    address: location.address
  };
}

function buildRoomsDescription(provider, location) {
  var description = "";

  for (var _len2 = arguments.length, rooms = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    rooms[_key2 - 2] = arguments[_key2];
  }

  for (var _i2 = 0, _rooms2 = rooms; _i2 < _rooms2.length; _i2++) {
    var room = _rooms2[_i2];
    description += "# Rum\n\n".concat(room.description, "\n\n");
  }

  description += "# ".concat(new Address(location.address).toString(), "\n\n").concat(location.description, "\n\n# ").concat(provider.name, "\n\n").concat(provider.description);
  return description;
}

function buildPropositionDescription(listing) {
  var FIELDS = {
    displayPublicTransport: "Kommunikationer",
    displayParking: "Parkering",
    displayServicesNearby: "Närservice",
    displaySurroundingsDescription: "Omgivning"
  };
  var description = listing.displayDescription();

  for (var _i3 = 0, _Object$entries = Object.entries(FIELDS); _i3 < _Object$entries.length; _i3++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
        fieldname = _Object$entries$_i[0],
        heading = _Object$entries$_i[1]; // @ts-ignore: Typescript does not detect that fieldname correspond to keys of callable methods


    var value = listing[fieldname]();

    if (!value) {
      continue;
    }

    description += "\n\n# ".concat(heading, "\n\n").concat(value);
  }

  return description;
}

var Shortlist = /*#__PURE__*/function () {
  function Shortlist(data) {
    _classCallCheck(this, Shortlist);

    _defineProperty(this, "data", void 0);

    _defineProperty(this, "propositions", void 0);

    _defineProperty(this, "stage", void 0);

    this.data = data;
    this.propositions = data.propositions.map(function (p) {
      return new Proposition(p);
    }).sort(function (p1, p2) {
      // Put the curated propositions first
      if (p1.curated !== p2.curated) {
        return p1.curated ? -1 : 1;
      } // Otherwise order by priority


      if (p1.priority !== p2.priority) {
        return p2.priority - p1.priority;
      } // otherwise order by recency


      return p2.created.valueOf() - p1.created.valueOf();
    }); // Calculate the current stage of the shortlist by taking the highest stage among propositions

    var stageIndex = -1,
        stage = STAGES[0];

    var _iterator = _createForOfIteratorHelper(this.propositions),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var p = _step.value;
        var index = STAGES.indexOf(p.stage);

        if (index > stageIndex) {
          stage = p.stage;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this.stage = stage;
  }

  _createClass(Shortlist, [{
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }, {
    key: "id",
    get: function get() {
      return this.data.id;
    }
  }, {
    key: "url",
    get: function get() {
      return "/shortlist/".concat(this.data.url);
    }
  }, {
    key: "name",
    get: function get() {
      return this.data.name;
    }
  }, {
    key: "owner",
    get: function get() {
      return this.data.owner;
    }
  }]);

  return Shortlist;
}();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * This error will be thrown if we received an answer but the status is not acceptable
 * Note that in case of network error or other unexpected issue other errors might bee thrown
 */


var StatusError = /*#__PURE__*/function (_Error) {
  _inherits(StatusError, _Error);

  var _super = _createSuper(StatusError);

  function StatusError(res, body) {
    var _this;

    _classCallCheck(this, StatusError);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "statusCode", void 0);

    _defineProperty(_assertThisInitialized(_this), "res", void 0);

    _defineProperty(_assertThisInitialized(_this), "responseText", void 0);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), StatusError);
    }

    _this.message = "Incorrect statusCode: ".concat(res.status);
    _this.statusCode = res.status;
    _this.res = res;
    _this.responseText = body;
    return _this;
  }

  _createClass(StatusError, [{
    key: "responseJson",
    get: function get() {
      return JSON.parse(this.responseText);
    }
  }]);

  return StatusError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var defaultClientOptions = {
  staging: false,
  apiKey: ""
};

var YtaApiClient = /*#__PURE__*/function () {
  function YtaApiClient(options) {
    _classCallCheck(this, YtaApiClient);

    _defineProperty(this, "opts", void 0);

    this.opts = _objectSpread({}, defaultClientOptions, {}, options);
  }

  _createClass(YtaApiClient, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, method, options) {
        var url, searchParams, headers, body, validStatuses, response, responseBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = new URL(path, this.origin);
                searchParams = options.searchParams || {};
                Object.entries(searchParams).forEach(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      key = _ref2[0],
                      value = _ref2[1];

                  return url.searchParams.append(key, value.toString());
                });
                headers = options.headers || new Headers(); // Authenticate all the requests if we have an API key.

                if (this.opts.apiKey) {
                  headers.set("Authorization", "Bearer ".concat(this.opts.apiKey));
                }

                body = null;
                if ("body" in options) body = options.body;

                if (!body && "data" in options) {
                  body = JSON.stringify(options.data);
                  headers.set("Content-Type", "application/json");
                }

                validStatuses = new Set(options.validStatuses || [200, 201, 202, 204]);
                _context.next = 11;
                return fetch(url.toString(), {
                  method: method,
                  headers: headers,
                  body: body
                });

              case 11:
                response = _context.sent;

                if (validStatuses.has(response.status)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 15;
                return response.text();

              case 15:
                responseBody = _context.sent;
                throw new StatusError(response, responseBody);

              case 17:
                return _context.abrupt("return", response);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x, _x2, _x3) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path) {
        var options,
            resp,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                _context2.next = 3;
                return this.request(path, "GET", options);

              case 3:
                resp = _context2.sent;
                _context2.next = 6;
                return resp.json();

              case 6:
                return _context2.abrupt("return", _context2.sent);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x4) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path, options) {
        var resp;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.request(path, "POST", options);

              case 2:
                resp = _context3.sent;
                _context3.next = 5;
                return resp.json();

              case 5:
                return _context3.abrupt("return", _context3.sent);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function post(_x5, _x6) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path, options) {
        var resp;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.request(path, "PUT", options);

              case 2:
                resp = _context4.sent;
                _context4.next = 5;
                return resp.json();

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function put(_x7, _x8) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "patch",
    value: function () {
      var _patch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path, options) {
        var resp;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.request(path, "PATCH", options);

              case 2:
                resp = _context5.sent;
                _context5.next = 5;
                return resp.json();

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function patch(_x9, _x10) {
        return _patch.apply(this, arguments);
      }

      return patch;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(path) {
        var options,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                _context6.next = 3;
                return this.request(path, "DELETE", options);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _delete(_x11) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
    /**
     * IMPLEMENTATION OF THE API ROUTES FOR THE APPLICATION BELOW
     */

  }, {
    key: "getListingById",
    value: function () {
      var _getListingById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
        var data;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.get("marketplace/listings/id/" + id);

              case 2:
                data = _context7.sent;
                return _context7.abrupt("return", new Listing(data));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getListingById(_x12) {
        return _getListingById.apply(this, arguments);
      }

      return getListingById;
    }()
  }, {
    key: "getListingByUrl",
    value: function () {
      var _getListingByUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(url) {
        var data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.get("marketplace/listings/url/" + url);

              case 2:
                data = _context8.sent;
                return _context8.abrupt("return", new Listing(data));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getListingByUrl(_x13) {
        return _getListingByUrl.apply(this, arguments);
      }

      return getListingByUrl;
    }()
  }, {
    key: "getListings",
    value: function () {
      var _getListings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(criteria) {
        var offset,
            limit,
            searchParams,
            _i,
            _Object$entries,
            _Object$entries$_i,
            _key,
            value,
            b,
            data,
            _args9 = arguments;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                offset = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : 0;
                limit = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : null;
                searchParams = {};

                for (_i = 0, _Object$entries = Object.entries(criteria); _i < _Object$entries.length; _i++) {
                  _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), _key = _Object$entries$_i[0], value = _Object$entries$_i[1];

                  if (_key === "bounds") {
                    b = value; // Need to cast to bounds otherwise typescript things value can still be a number or anything else

                    searchParams[_key] = "".concat(b.south, ",").concat(b.west, ",").concat(b.north, ",").concat(b.east);
                  } else {
                    searchParams[_key] = value; // Need to cast type bevause typescript is not clever enough to understand we handled the bounds case
                  }
                }

                if (limit) {
                  searchParams.limit = limit;
                }

                if (offset) {
                  searchParams.offset = offset;
                }

                _context9.next = 8;
                return this.get("marketplace/listings", {
                  searchParams: searchParams
                });

              case 8:
                data = _context9.sent;
                return _context9.abrupt("return", _objectSpread({}, data, {
                  results: data.results.map(function (l) {
                    return new Listing(l);
                  })
                }));

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getListings(_x14) {
        return _getListings.apply(this, arguments);
      }

      return getListings;
    }()
  }, {
    key: "getListingPoints",
    value: function () {
      var _getListingPoints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(criteria) {
        var searchParams;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                searchParams = criteria; // Needs casting because of https://github.com/microsoft/TypeScript/issues/13195

                _context10.next = 3;
                return this.get("marketplace/listings/points", {
                  searchParams: searchParams
                });

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getListingPoints(_x15) {
        return _getListingPoints.apply(this, arguments);
      }

      return getListingPoints;
    }()
  }, {
    key: "getUploadedListings",
    value: function () {
      var _getUploadedListings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.get("marketplace/raw_listings");

              case 2:
                return _context11.abrupt("return", _context11.sent);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getUploadedListings() {
        return _getUploadedListings.apply(this, arguments);
      }

      return getUploadedListings;
    }()
  }, {
    key: "getUploadedListingById",
    value: function () {
      var _getUploadedListingById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(id) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.get("marketplace/raw_listings/" + id);

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getUploadedListingById(_x16) {
        return _getUploadedListingById.apply(this, arguments);
      }

      return getUploadedListingById;
    }()
  }, {
    key: "createUploadedListing",
    value: function () {
      var _createUploadedListing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(data) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.post("marketplace/raw_listings", {
                  data: data
                });

              case 2:
                return _context13.abrupt("return", _context13.sent);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function createUploadedListing(_x17) {
        return _createUploadedListing.apply(this, arguments);
      }

      return createUploadedListing;
    }()
  }, {
    key: "updateUploadedListing",
    value: function () {
      var _updateUploadedListing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(id, data) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this.put("marketplace/raw_listings/" + id, {
                  data: data
                }));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function updateUploadedListing(_x18, _x19) {
        return _updateUploadedListing.apply(this, arguments);
      }

      return updateUploadedListing;
    }()
  }, {
    key: "getBrokerById",
    value: function () {
      var _getBrokerById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(id) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.get("marketplace/brokers/" + id);

              case 2:
                return _context15.abrupt("return", _context15.sent);

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getBrokerById(_x20) {
        return _getBrokerById.apply(this, arguments);
      }

      return getBrokerById;
    }()
  }, {
    key: "getContactById",
    value: function () {
      var _getContactById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(id) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.get("marketplace/contacts/" + id);

              case 2:
                return _context16.abrupt("return", _context16.sent);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getContactById(_x21) {
        return _getContactById.apply(this, arguments);
      }

      return getContactById;
    }()
  }, {
    key: "getServicedOfficeServices",
    value: function () {
      var _getServicedOfficeServices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.get("serviced_offices/services");

              case 2:
                return _context17.abrupt("return", _context17.sent);

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getServicedOfficeServices() {
        return _getServicedOfficeServices.apply(this, arguments);
      }

      return getServicedOfficeServices;
    }()
  }, {
    key: "createServicedOfficeService",
    value: function () {
      var _createServicedOfficeService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(data) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.post("serviced_offices/services", {
                  data: data
                });

              case 2:
                return _context18.abrupt("return", _context18.sent);

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function createServicedOfficeService(_x22) {
        return _createServicedOfficeService.apply(this, arguments);
      }

      return createServicedOfficeService;
    }()
  }, {
    key: "getServicedOfficeServiceById",
    value: function () {
      var _getServicedOfficeServiceById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(id) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.get("serviced_offices/services/" + id);

              case 2:
                return _context19.abrupt("return", _context19.sent);

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getServicedOfficeServiceById(_x23) {
        return _getServicedOfficeServiceById.apply(this, arguments);
      }

      return getServicedOfficeServiceById;
    }()
  }, {
    key: "updateServicedOfficeService",
    value: function () {
      var _updateServicedOfficeService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(id, data) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.put("serviced_offices/services/" + id, {
                  data: data
                });

              case 2:
                return _context20.abrupt("return", _context20.sent);

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function updateServicedOfficeService(_x24, _x25) {
        return _updateServicedOfficeService.apply(this, arguments);
      }

      return updateServicedOfficeService;
    }()
  }, {
    key: "getServicedOfficeProviders",
    value: function () {
      var _getServicedOfficeProviders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.get("serviced_offices/providers");

              case 2:
                return _context21.abrupt("return", _context21.sent);

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getServicedOfficeProviders() {
        return _getServicedOfficeProviders.apply(this, arguments);
      }

      return getServicedOfficeProviders;
    }()
  }, {
    key: "createServicedOfficeProvider",
    value: function () {
      var _createServicedOfficeProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(data) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.post("serviced_offices/providers", {
                  data: data
                });

              case 2:
                return _context22.abrupt("return", _context22.sent);

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function createServicedOfficeProvider(_x26) {
        return _createServicedOfficeProvider.apply(this, arguments);
      }

      return createServicedOfficeProvider;
    }()
  }, {
    key: "getServicedOfficeProviderById",
    value: function () {
      var _getServicedOfficeProviderById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(id) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.get("serviced_offices/providers/" + id);

              case 2:
                return _context23.abrupt("return", _context23.sent);

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function getServicedOfficeProviderById(_x27) {
        return _getServicedOfficeProviderById.apply(this, arguments);
      }

      return getServicedOfficeProviderById;
    }()
  }, {
    key: "updateServicedOfficeProvider",
    value: function () {
      var _updateServicedOfficeProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(id, data) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.put("serviced_offices/providers/" + id, {
                  data: data
                });

              case 2:
                return _context24.abrupt("return", _context24.sent);

              case 3:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function updateServicedOfficeProvider(_x28, _x29) {
        return _updateServicedOfficeProvider.apply(this, arguments);
      }

      return updateServicedOfficeProvider;
    }()
  }, {
    key: "getServicedOfficeFloorById",
    value: function () {
      var _getServicedOfficeFloorById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(id) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return this.get("serviced_offices/floors/" + id);

              case 2:
                return _context25.abrupt("return", _context25.sent);

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function getServicedOfficeFloorById(_x30) {
        return _getServicedOfficeFloorById.apply(this, arguments);
      }

      return getServicedOfficeFloorById;
    }()
  }, {
    key: "createServicedOfficeFloor",
    value: function () {
      var _createServicedOfficeFloor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(data) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.post("serviced_offices/floors", {
                  data: data
                });

              case 2:
                return _context26.abrupt("return", _context26.sent);

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function createServicedOfficeFloor(_x31) {
        return _createServicedOfficeFloor.apply(this, arguments);
      }

      return createServicedOfficeFloor;
    }()
  }, {
    key: "updateServicedOfficeFloor",
    value: function () {
      var _updateServicedOfficeFloor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(id, data) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.put("serviced_offices/floors/" + id, {
                  data: data
                });

              case 2:
                return _context27.abrupt("return", _context27.sent);

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function updateServicedOfficeFloor(_x32, _x33) {
        return _updateServicedOfficeFloor.apply(this, arguments);
      }

      return updateServicedOfficeFloor;
    }()
  }, {
    key: "partialUpdateServicedOfficeFloor",
    value: function () {
      var _partialUpdateServicedOfficeFloor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(id, data) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.patch("serviced_offices/floors/" + id, {
                  data: data
                });

              case 2:
                return _context28.abrupt("return", _context28.sent);

              case 3:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function partialUpdateServicedOfficeFloor(_x34, _x35) {
        return _partialUpdateServicedOfficeFloor.apply(this, arguments);
      }

      return partialUpdateServicedOfficeFloor;
    }()
  }, {
    key: "getServicedOfficeLocations",
    value: function () {
      var _getServicedOfficeLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.get("serviced_offices/locations");

              case 2:
                return _context29.abrupt("return", _context29.sent);

              case 3:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function getServicedOfficeLocations() {
        return _getServicedOfficeLocations.apply(this, arguments);
      }

      return getServicedOfficeLocations;
    }()
  }, {
    key: "createServicedOfficeLocation",
    value: function () {
      var _createServicedOfficeLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(data) {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.post("serviced_offices/locations", {
                  data: data
                });

              case 2:
                return _context30.abrupt("return", _context30.sent);

              case 3:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function createServicedOfficeLocation(_x36) {
        return _createServicedOfficeLocation.apply(this, arguments);
      }

      return createServicedOfficeLocation;
    }()
  }, {
    key: "getServicedOfficeLocationById",
    value: function () {
      var _getServicedOfficeLocationById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(id) {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.get("serviced_offices/locations/" + id);

              case 2:
                return _context31.abrupt("return", _context31.sent);

              case 3:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function getServicedOfficeLocationById(_x37) {
        return _getServicedOfficeLocationById.apply(this, arguments);
      }

      return getServicedOfficeLocationById;
    }()
  }, {
    key: "updateServicedOfficeLocation",
    value: function () {
      var _updateServicedOfficeLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(id, data) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this.put("serviced_offices/locations/" + id, {
                  data: data
                });

              case 2:
                return _context32.abrupt("return", _context32.sent);

              case 3:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function updateServicedOfficeLocation(_x38, _x39) {
        return _updateServicedOfficeLocation.apply(this, arguments);
      }

      return updateServicedOfficeLocation;
    }()
  }, {
    key: "deleteServicedOfficeLocation",
    value: function () {
      var _deleteServicedOfficeLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(id) {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this.delete("serviced_offices/locations/" + id);

              case 2:
                return _context33.abrupt("return", _context33.sent);

              case 3:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function deleteServicedOfficeLocation(_x40) {
        return _deleteServicedOfficeLocation.apply(this, arguments);
      }

      return deleteServicedOfficeLocation;
    }()
  }, {
    key: "downloadServicedOfficeLocationRooms",
    value: function () {
      var _downloadServicedOfficeLocationRooms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(id) {
        var res;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return this.request("serviced_offices/locations/".concat(id, "/download_rooms"), "GET", {});

              case 2:
                res = _context34.sent;
                _context34.next = 5;
                return res.blob();

              case 5:
                return _context34.abrupt("return", _context34.sent);

              case 6:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function downloadServicedOfficeLocationRooms(_x41) {
        return _downloadServicedOfficeLocationRooms.apply(this, arguments);
      }

      return downloadServicedOfficeLocationRooms;
    }()
  }, {
    key: "uploadServicedOfficeLocationRooms",
    value: function () {
      var _uploadServicedOfficeLocationRooms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(id, body) {
        var headers;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                if (!(body.type !== "text/csv")) {
                  _context35.next = 2;
                  break;
                }

                throw new Error("Set the data type to 'text/csv'");

              case 2:
                headers = new Headers({
                  "Content-Type": "text/csv"
                });
                _context35.next = 5;
                return this.patch("serviced_offices/locations/".concat(id, "/update_rooms"), {
                  body: body,
                  headers: headers
                });

              case 5:
                return _context35.abrupt("return", _context35.sent);

              case 6:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function uploadServicedOfficeLocationRooms(_x42, _x43) {
        return _uploadServicedOfficeLocationRooms.apply(this, arguments);
      }

      return uploadServicedOfficeLocationRooms;
    }()
  }, {
    key: "getServicedOfficeRooms",
    value: function () {
      var _getServicedOfficeRooms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        var filters,
            _args36 = arguments;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                filters = _args36.length > 0 && _args36[0] !== undefined ? _args36[0] : {};
                _context36.next = 3;
                return this.get("serviced_offices/rooms", {
                  searchParams: filters // Needs casting because of https://github.com/microsoft/TypeScript/issues/13195

                });

              case 3:
                return _context36.abrupt("return", _context36.sent);

              case 4:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function getServicedOfficeRooms() {
        return _getServicedOfficeRooms.apply(this, arguments);
      }

      return getServicedOfficeRooms;
    }()
  }, {
    key: "createServicedOfficeRoom",
    value: function () {
      var _createServicedOfficeRoom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(data) {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return this.post("serviced_offices/rooms", {
                  data: data
                });

              case 2:
                return _context37.abrupt("return", _context37.sent);

              case 3:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function createServicedOfficeRoom(_x44) {
        return _createServicedOfficeRoom.apply(this, arguments);
      }

      return createServicedOfficeRoom;
    }()
  }, {
    key: "getServicedOfficeRoomById",
    value: function () {
      var _getServicedOfficeRoomById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(id) {
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return this.get("serviced_offices/rooms/" + id);

              case 2:
                return _context38.abrupt("return", _context38.sent);

              case 3:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function getServicedOfficeRoomById(_x45) {
        return _getServicedOfficeRoomById.apply(this, arguments);
      }

      return getServicedOfficeRoomById;
    }()
  }, {
    key: "deleteServicedOfficeRoom",
    value: function () {
      var _deleteServicedOfficeRoom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(id) {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return this.delete("serviced_offices/rooms/" + id);

              case 2:
                return _context39.abrupt("return", _context39.sent);

              case 3:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function deleteServicedOfficeRoom(_x46) {
        return _deleteServicedOfficeRoom.apply(this, arguments);
      }

      return deleteServicedOfficeRoom;
    }()
  }, {
    key: "updateServicedOfficeRoom",
    value: function () {
      var _updateServicedOfficeRoom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(id, data) {
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return this.put("serviced_offices/rooms/" + id, {
                  data: data
                });

              case 2:
                return _context40.abrupt("return", _context40.sent);

              case 3:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function updateServicedOfficeRoom(_x47, _x48) {
        return _updateServicedOfficeRoom.apply(this, arguments);
      }

      return updateServicedOfficeRoom;
    }()
  }, {
    key: "getServicedOfficeRoomByUrl",
    value: function () {
      var _getServicedOfficeRoomByUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(url) {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return this.get("serviced_offices/rooms/url/" + url);

              case 2:
                return _context41.abrupt("return", _context41.sent);

              case 3:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function getServicedOfficeRoomByUrl(_x49) {
        return _getServicedOfficeRoomByUrl.apply(this, arguments);
      }

      return getServicedOfficeRoomByUrl;
    }()
  }, {
    key: "createProposition",
    value: function () {
      var _createProposition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(data) {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.next = 2;
                return this.post("shortlists/propositions", {
                  data: data
                });

              case 2:
                return _context42.abrupt("return", _context42.sent);

              case 3:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function createProposition(_x50) {
        return _createProposition.apply(this, arguments);
      }

      return createProposition;
    }()
  }, {
    key: "updateProposition",
    value: function () {
      var _updateProposition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(id, data) {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return this.put("shortlists/propositions/" + id, {
                  data: data
                });

              case 2:
                return _context43.abrupt("return", _context43.sent);

              case 3:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function updateProposition(_x51, _x52) {
        return _updateProposition.apply(this, arguments);
      }

      return updateProposition;
    }()
  }, {
    key: "partialUpdateProposition",
    value: function () {
      var _partialUpdateProposition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(id, data) {
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.next = 2;
                return this.patch("shortlists/propositions/" + id, {
                  data: data
                });

              case 2:
                return _context44.abrupt("return", _context44.sent);

              case 3:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function partialUpdateProposition(_x53, _x54) {
        return _partialUpdateProposition.apply(this, arguments);
      }

      return partialUpdateProposition;
    }()
  }, {
    key: "deleteProposition",
    value: function () {
      var _deleteProposition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(id) {
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return this.delete("shortlists/propositions/" + id);

              case 2:
                return _context45.abrupt("return", _context45.sent);

              case 3:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function deleteProposition(_x55) {
        return _deleteProposition.apply(this, arguments);
      }

      return deleteProposition;
    }()
  }, {
    key: "getPropositionById",
    value: function () {
      var _getPropositionById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(id) {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.next = 2;
                return this.get("shortlists/propositions/" + id);

              case 2:
                return _context46.abrupt("return", _context46.sent);

              case 3:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function getPropositionById(_x56) {
        return _getPropositionById.apply(this, arguments);
      }

      return getPropositionById;
    }()
  }, {
    key: "requestShowingForProposition",
    value: function () {
      var _requestShowingForProposition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(id) {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.next = 2;
                return this.post("shortlists/propositions/".concat(id, "/request_showing"), {});

              case 2:
                return _context47.abrupt("return", _context47.sent);

              case 3:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function requestShowingForProposition(_x57) {
        return _requestShowingForProposition.apply(this, arguments);
      }

      return requestShowingForProposition;
    }()
  }, {
    key: "getShortlists",
    value: function () {
      var _getShortlists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
        var criteria,
            searchParams,
            _args48 = arguments;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                criteria = _args48.length > 0 && _args48[0] !== undefined ? _args48[0] : {};
                searchParams = {};

                if (criteria.nameStartsWith) {
                  searchParams.name = criteria.nameStartsWith;
                }

                _context48.next = 5;
                return this.get("shortlists", {
                  searchParams: searchParams
                });

              case 5:
                return _context48.abrupt("return", _context48.sent);

              case 6:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function getShortlists() {
        return _getShortlists.apply(this, arguments);
      }

      return getShortlists;
    }()
  }, {
    key: "createShortlist",
    value: function () {
      var _createShortlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(data) {
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _context49.next = 2;
                return this.post("shortlists", {
                  data: data
                });

              case 2:
                return _context49.abrupt("return", _context49.sent);

              case 3:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function createShortlist(_x58) {
        return _createShortlist.apply(this, arguments);
      }

      return createShortlist;
    }()
  }, {
    key: "updateShortlist",
    value: function () {
      var _updateShortlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(id, data) {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.next = 2;
                return this.put("shortlists/id/" + id, {
                  data: data
                });

              case 2:
                return _context50.abrupt("return", _context50.sent);

              case 3:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function updateShortlist(_x59, _x60) {
        return _updateShortlist.apply(this, arguments);
      }

      return updateShortlist;
    }()
  }, {
    key: "deleteShortlist",
    value: function () {
      var _deleteShortlist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(id) {
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                _context51.next = 2;
                return this.delete("shortlists/id/" + id);

              case 2:
                return _context51.abrupt("return", _context51.sent);

              case 3:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function deleteShortlist(_x61) {
        return _deleteShortlist.apply(this, arguments);
      }

      return deleteShortlist;
    }()
  }, {
    key: "getShortlistById",
    value: function () {
      var _getShortlistById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(id) {
        var res;
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                _context52.next = 2;
                return this.get("shortlists/id/" + id);

              case 2:
                res = _context52.sent;
                return _context52.abrupt("return", new Shortlist(res));

              case 4:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function getShortlistById(_x62) {
        return _getShortlistById.apply(this, arguments);
      }

      return getShortlistById;
    }()
  }, {
    key: "getShortlistByUrl",
    value: function () {
      var _getShortlistByUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(url) {
        var res;
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.next = 2;
                return this.get("shortlists/url/" + url);

              case 2:
                res = _context53.sent;
                return _context53.abrupt("return", new Shortlist(res));

              case 4:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function getShortlistByUrl(_x63) {
        return _getShortlistByUrl.apply(this, arguments);
      }

      return getShortlistByUrl;
    }()
  }, {
    key: "getDealInfoByHubspotId",
    value: function () {
      var _getDealInfoByHubspotId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(id) {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.next = 2;
                return this.get("deal_info/hs_deal/" + id);

              case 2:
                return _context54.abrupt("return", _context54.sent);

              case 3:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));

      function getDealInfoByHubspotId(_x64) {
        return _getDealInfoByHubspotId.apply(this, arguments);
      }

      return getDealInfoByHubspotId;
    }()
  }, {
    key: "getEnhancementById",
    value: function () {
      var _getEnhancementById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(id) {
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _context55.next = 2;
                return this.get("marketplace/enhancements/" + id);

              case 2:
                return _context55.abrupt("return", _context55.sent);

              case 3:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function getEnhancementById(_x65) {
        return _getEnhancementById.apply(this, arguments);
      }

      return getEnhancementById;
    }()
  }, {
    key: "createEnhancement",
    value: function () {
      var _createEnhancement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(data) {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.next = 2;
                return this.post("marketplace/enhancements", {
                  data: data
                });

              case 2:
                return _context56.abrupt("return", _context56.sent);

              case 3:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));

      function createEnhancement(_x66) {
        return _createEnhancement.apply(this, arguments);
      }

      return createEnhancement;
    }()
  }, {
    key: "updateEnhancement",
    value: function () {
      var _updateEnhancement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(data) {
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                _context57.next = 2;
                return this.put("marketplace/enhancements/" + data.listing, {
                  data: data
                });

              case 2:
                return _context57.abrupt("return", _context57.sent);

              case 3:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function updateEnhancement(_x67) {
        return _updateEnhancement.apply(this, arguments);
      }

      return updateEnhancement;
    }()
  }, {
    key: "getLockinCompanies",
    value: function () {
      var _getLockinCompanies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.next = 2;
                return this.get("lock_in/companies");

              case 2:
                return _context58.abrupt("return", _context58.sent);

              case 3:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));

      function getLockinCompanies() {
        return _getLockinCompanies.apply(this, arguments);
      }

      return getLockinCompanies;
    }()
  }, {
    key: "getLockinCompanyById",
    value: function () {
      var _getLockinCompanyById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(id) {
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.next = 2;
                return this.get("lock_in/companies/" + id);

              case 2:
                return _context59.abrupt("return", _context59.sent);

              case 3:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));

      function getLockinCompanyById(_x68) {
        return _getLockinCompanyById.apply(this, arguments);
      }

      return getLockinCompanyById;
    }()
  }, {
    key: "createLockinCompany",
    value: function () {
      var _createLockinCompany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(data) {
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return this.post("lock_in/companies", {
                  data: data
                });

              case 2:
                return _context60.abrupt("return", _context60.sent);

              case 3:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function createLockinCompany(_x69) {
        return _createLockinCompany.apply(this, arguments);
      }

      return createLockinCompany;
    }()
  }, {
    key: "updateLockinCompany",
    value: function () {
      var _updateLockinCompany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(id, data) {
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.next = 2;
                return this.put("lock_in/companies/" + id, {
                  data: data
                });

              case 2:
                return _context61.abrupt("return", _context61.sent);

              case 3:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));

      function updateLockinCompany(_x70, _x71) {
        return _updateLockinCompany.apply(this, arguments);
      }

      return updateLockinCompany;
    }()
  }, {
    key: "deleteLockinCompany",
    value: function () {
      var _deleteLockinCompany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(id) {
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.next = 2;
                return this.delete("lock_in/companies/" + id);

              case 2:
                return _context62.abrupt("return", _context62.sent);

              case 3:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));

      function deleteLockinCompany(_x72) {
        return _deleteLockinCompany.apply(this, arguments);
      }

      return deleteLockinCompany;
    }()
  }, {
    key: "getLockinContacts",
    value: function () {
      var _getLockinContacts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                _context63.next = 2;
                return this.get("lock_in/contacts");

              case 2:
                return _context63.abrupt("return", _context63.sent);

              case 3:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function getLockinContacts() {
        return _getLockinContacts.apply(this, arguments);
      }

      return getLockinContacts;
    }()
  }, {
    key: "getLockinContactById",
    value: function () {
      var _getLockinContactById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(id) {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.next = 2;
                return this.get("lock_in/contacts/" + id);

              case 2:
                return _context64.abrupt("return", _context64.sent);

              case 3:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function getLockinContactById(_x73) {
        return _getLockinContactById.apply(this, arguments);
      }

      return getLockinContactById;
    }()
  }, {
    key: "createLockinContact",
    value: function () {
      var _createLockinContact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(data) {
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                _context65.next = 2;
                return this.post("lock_in/contacts", {
                  data: data
                });

              case 2:
                return _context65.abrupt("return", _context65.sent);

              case 3:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function createLockinContact(_x74) {
        return _createLockinContact.apply(this, arguments);
      }

      return createLockinContact;
    }()
  }, {
    key: "updateLockinContact",
    value: function () {
      var _updateLockinContact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(id, data) {
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                _context66.next = 2;
                return this.put("lock_in/contacts/" + id, {
                  data: data
                });

              case 2:
                return _context66.abrupt("return", _context66.sent);

              case 3:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function updateLockinContact(_x75, _x76) {
        return _updateLockinContact.apply(this, arguments);
      }

      return updateLockinContact;
    }()
  }, {
    key: "deleteLockinContact",
    value: function () {
      var _deleteLockinContact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(id) {
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                _context67.next = 2;
                return this.delete("lock_in/contacts/" + id);

              case 2:
                return _context67.abrupt("return", _context67.sent);

              case 3:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));

      function deleteLockinContact(_x77) {
        return _deleteLockinContact.apply(this, arguments);
      }

      return deleteLockinContact;
    }()
  }, {
    key: "sendLockinMessages",
    value: function () {
      var _sendLockinMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(data) {
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.next = 2;
                return this.post("lock_in/send_message", {
                  data: data
                });

              case 2:
                return _context68.abrupt("return", _context68.sent);

              case 3:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));

      function sendLockinMessages(_x78) {
        return _sendLockinMessages.apply(this, arguments);
      }

      return sendLockinMessages;
    }()
  }, {
    key: "generateLockinMessagesPreview",
    value: function () {
      var _generateLockinMessagesPreview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(data) {
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                _context69.next = 2;
                return this.post("lock_in/preview_message", {
                  data: data
                });

              case 2:
                return _context69.abrupt("return", _context69.sent);

              case 3:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function generateLockinMessagesPreview(_x79) {
        return _generateLockinMessagesPreview.apply(this, arguments);
      }

      return generateLockinMessagesPreview;
    }()
  }, {
    key: "getDigitalContracts",
    value: function () {
      var _getDigitalContracts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70() {
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                _context70.next = 2;
                return this.get("digital_contracts");

              case 2:
                return _context70.abrupt("return", _context70.sent);

              case 3:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));

      function getDigitalContracts() {
        return _getDigitalContracts.apply(this, arguments);
      }

      return getDigitalContracts;
    }()
  }, {
    key: "getDigitalContractById",
    value: function () {
      var _getDigitalContractById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(id) {
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                _context71.next = 2;
                return this.get("digital_contracts/" + id);

              case 2:
                return _context71.abrupt("return", _context71.sent);

              case 3:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));

      function getDigitalContractById(_x80) {
        return _getDigitalContractById.apply(this, arguments);
      }

      return getDigitalContractById;
    }()
  }, {
    key: "createDigitalContract",
    value: function () {
      var _createDigitalContract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(data) {
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                _context72.next = 2;
                return this.post("digital_contracts", {
                  data: data
                });

              case 2:
                return _context72.abrupt("return", _context72.sent);

              case 3:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, this);
      }));

      function createDigitalContract(_x81) {
        return _createDigitalContract.apply(this, arguments);
      }

      return createDigitalContract;
    }()
  }, {
    key: "getSearchSpecifications",
    value: function () {
      var _getSearchSpecifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73() {
        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                _context73.next = 2;
                return this.get("search_specifications");

              case 2:
                return _context73.abrupt("return", _context73.sent);

              case 3:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73, this);
      }));

      function getSearchSpecifications() {
        return _getSearchSpecifications.apply(this, arguments);
      }

      return getSearchSpecifications;
    }()
  }, {
    key: "getSearchSpecificationById",
    value: function () {
      var _getSearchSpecificationById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(id) {
        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                _context74.next = 2;
                return this.get("search_specifications/" + id);

              case 2:
                return _context74.abrupt("return", _context74.sent);

              case 3:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, this);
      }));

      function getSearchSpecificationById(_x82) {
        return _getSearchSpecificationById.apply(this, arguments);
      }

      return getSearchSpecificationById;
    }()
  }, {
    key: "createSearchSpecification",
    value: function () {
      var _createSearchSpecification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(data) {
        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                _context75.next = 2;
                return this.post("search_specifications", {
                  data: data
                });

              case 2:
                return _context75.abrupt("return", _context75.sent);

              case 3:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, this);
      }));

      function createSearchSpecification(_x83) {
        return _createSearchSpecification.apply(this, arguments);
      }

      return createSearchSpecification;
    }()
  }, {
    key: "updateSearchSpecification",
    value: function () {
      var _updateSearchSpecification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(id, data) {
        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                _context76.next = 2;
                return this.put("search_specifications/" + id, {
                  data: data
                });

              case 2:
                return _context76.abrupt("return", _context76.sent);

              case 3:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this);
      }));

      function updateSearchSpecification(_x84, _x85) {
        return _updateSearchSpecification.apply(this, arguments);
      }

      return updateSearchSpecification;
    }()
  }, {
    key: "getOffers",
    value: function () {
      var _getOffers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(criteria) {
        var offset,
            limit,
            searchParams,
            _i2,
            _Object$entries2,
            _Object$entries2$_i,
            _key2,
            value,
            data,
            _args77 = arguments;

        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                offset = _args77.length > 1 && _args77[1] !== undefined ? _args77[1] : 0;
                limit = _args77.length > 2 && _args77[2] !== undefined ? _args77[2] : null;
                searchParams = {};

                for (_i2 = 0, _Object$entries2 = Object.entries(criteria); _i2 < _Object$entries2.length; _i2++) {
                  _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), _key2 = _Object$entries2$_i[0], value = _Object$entries2$_i[1];
                  searchParams[_key2] = value;
                }

                if (limit) {
                  searchParams.limit = limit;
                }

                if (offset) {
                  searchParams.offset = offset;
                }

                _context77.next = 8;
                return this.get("shortlists/offers", {
                  searchParams: searchParams
                });

              case 8:
                data = _context77.sent;
                return _context77.abrupt("return", data);

              case 10:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this);
      }));

      function getOffers(_x86) {
        return _getOffers.apply(this, arguments);
      }

      return getOffers;
    }()
  }, {
    key: "createFormLead",
    value: function () {
      var _createFormLead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(data) {
        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                _context78.next = 2;
                return this.post("form_leads", {
                  data: data
                });

              case 2:
                return _context78.abrupt("return", _context78.sent);

              case 3:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, this);
      }));

      function createFormLead(_x87) {
        return _createFormLead.apply(this, arguments);
      }

      return createFormLead;
    }()
  }, {
    key: "updateFormLead",
    value: function () {
      var _updateFormLead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(id, data) {
        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                _context79.next = 2;
                return this.post("form_leads/" + id, {
                  data: data
                });

              case 2:
                return _context79.abrupt("return", _context79.sent);

              case 3:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79, this);
      }));

      function updateFormLead(_x88, _x89) {
        return _updateFormLead.apply(this, arguments);
      }

      return updateFormLead;
    }()
  }, {
    key: "origin",
    get: function get() {
      return this.opts.staging ? "https://staging-api.yta.se" : "https://api.yta.se";
    }
  }]);

  return YtaApiClient;
}();

var RoomListingView = /*#__PURE__*/function () {
  function RoomListingView(room, location, provider) {
    _classCallCheck(this, RoomListingView);

    _defineProperty(this, "room", void 0);

    _defineProperty(this, "loc", void 0);

    _defineProperty(this, "prov", void 0);

    _defineProperty(this, "created", void 0);

    _defineProperty(this, "address", void 0);

    this.room = room;
    this.loc = location;
    this.prov = provider;
    this.created = new Date(room.created);
    this.address = new Address(location.address);
  }
  /**
   * Fields specific to the room view not available through listing
   */


  _createClass(RoomListingView, [{
    key: "displayExtraServices",
    value: function displayExtraServices() {
      return this.loc.extra_services;
    }
    /**
     * Fields common with listings
     */

  }, {
    key: "displayAge",
    value: function displayAge() {
      /**
       * The age is not relevant for a room, so we just return an empty string as we don't want to display anything
       */
      return "";
    }
  }, {
    key: "displayAvailability",
    value: function displayAvailability() {
      return this.room.availability ? this.room.availability : "Tillgänglig";
    }
  }, {
    key: "displayConstructionYear",
    value: function displayConstructionYear() {
      return "";
    }
  }, {
    key: "displayDescription",
    value: function displayDescription() {
      return "".concat(this.room.description, "\n\n    ").concat(this.address.toString(), "\n    ").concat(this.loc.description, "\n\n    ").concat(this.prov.name, "\n    ").concat(this.prov.description);
    }
  }, {
    key: "displayFloor",
    value: function displayFloor() {
      return "";
    }
  }, {
    key: "displayNeighbordhood",
    value: function displayNeighbordhood() {
      return "";
    }
  }, {
    key: "displayParking",
    value: function displayParking() {
      return "";
    }
  }, {
    key: "displayPublicTransport",
    value: function displayPublicTransport() {
      return "";
    }
  }, {
    key: "displayEstimatedRent",
    value: function displayEstimatedRent() {
      return "".concat(formatInt(this.monthlyRent), " kr/m\xE5n");
    }
  }, {
    key: "displayActualRent",
    value: function displayActualRent() {
      return this.displayEstimatedRent();
    }
    /**
     * @deprecated since version 1.6.0. Use displayActualRent or displayEstimatedRent instead.
     */

  }, {
    key: "displayRent",
    value: function displayRent() {
      return this.displayEstimatedRent();
    }
  }, {
    key: "displayRentDetails",
    value: function displayRentDetails() {
      return "";
    }
  }, {
    key: "displayServicesNearby",
    value: function displayServicesNearby() {
      return "";
    }
  }, {
    key: "displayShortDescription",
    value: function displayShortDescription() {
      return "";
    }
  }, {
    key: "displaySize",
    value: function displaySize() {
      return "".concat(this.room.size, " m\xB2");
    }
  }, {
    key: "displaySurroundingsDescription",
    value: function displaySurroundingsDescription() {
      return "";
    }
  }, {
    key: "displayTitle",
    value: function displayTitle() {
      return this.room.title;
    }
  }, {
    key: "displayType",
    value: function displayType() {
      return "Kontorshotell rum";
    }
  }, {
    key: "displayWorkspaces",
    value: function displayWorkspaces() {
      return "".concat(this.minWorkspaces, " - ").concat(this.maxWorkspaces, " arbetsplatser");
    }
  }, {
    key: "hasWindow",
    get: function get() {
      return this.room.has_window;
    }
  }, {
    key: "isExample",
    get: function get() {
      return this.room.is_example;
    }
  }, {
    key: "services",
    get: function get() {
      return [].concat(_toConsumableArray(this.loc.services), _toConsumableArray(this.prov.services));
    }
  }, {
    key: "listing",
    get: function get() {
      return this.room.listing;
    }
  }, {
    key: "provider",
    get: function get() {
      return this.prov;
    }
  }, {
    key: "location",
    get: function get() {
      return this.loc;
    }
  }, {
    key: "id",
    get: function get() {
      return this.room.id;
    }
  }, {
    key: "isOverridden",
    get: function get() {
      return true;
    }
  }, {
    key: "isPublic",
    get: function get() {
      return this.room.state === "PUB";
    }
  }, {
    key: "isListed",
    get: function get() {
      return this.room.state === "PUB" || this.room.state === "OFF";
    }
  }, {
    key: "isOffice",
    get: function get() {
      return true;
    }
  }, {
    key: "isServicedOffice",
    get: function get() {
      return true;
    }
  }, {
    key: "images",
    get: function get() {
      var images = [].concat(_toConsumableArray(this.room.images), _toConsumableArray(this.loc.images)).map(function (url) {
        return {
          url: url,
          tour: false
        };
      });

      if (images.length == 0) {
        return [{
          url: DEFAULT_LISTING_IMAGE_URL,
          tour: false
        }];
      }

      return images;
    }
  }, {
    key: "floorplans",
    get: function get() {
      return [].concat(_toConsumableArray(this.room.floorplans), _toConsumableArray(this.loc.floorplans));
    }
  }, {
    key: "documents",
    get: function get() {
      return [].concat(_toConsumableArray(this.loc.documents), _toConsumableArray(this.prov.documents));
    }
  }, {
    key: "url",
    get: function get() {
      return "".concat(this.room.url);
    }
  }, {
    key: "metricRent",
    get: function get() {
      return this.room.price / this.room.size;
    }
  }, {
    key: "monthlyRent",
    get: function get() {
      return this.room.price;
    }
  }, {
    key: "listMonthlyRent",
    get: function get() {
      return this.room.price;
    }
  }, {
    key: "bestMonthlyRent",
    get: function get() {
      return this.room.official_minimum_price || this.room.price;
    }
  }, {
    key: "hasDiscount",
    get: function get() {
      return this.room.official_minimum_price && this.room.official_minimum_price < this.room.price;
    }
  }, {
    key: "virtualTours",
    get: function get() {
      return [];
    }
  }, {
    key: "rentConfidence",
    get: function get() {
      return 5;
    }
  }, {
    key: "minSize",
    get: function get() {
      return this.room.size;
    }
  }, {
    key: "maxSize",
    get: function get() {
      return this.room.size;
    }
  }, {
    key: "maxWorkspaces",
    get: function get() {
      return this.room.max_workspaces;
    }
  }, {
    key: "minWorkspaces",
    get: function get() {
      return Math.floor(this.room.max_workspaces * 0.6);
    }
  }, {
    key: "contact",
    get: function get() {
      return null;
    }
  }, {
    key: "broker",
    get: function get() {
      return null;
    }
  }, {
    key: "legacyContactData",
    get: function get() {
      return null;
    }
  }]);

  return RoomListingView;
}();

export { Address, Listing, Proposition, RoomListingView, Shortlist, StatusError, YtaApiClient, listingToPropositionPayload, roomsToPropositionPayload };